module.exports = __webpack_public_path__ + "static/img/loading.6c0f6b4b.gif";